import {DataObjectId, Hub} from 'yougile-model'
import {ChatSubscribers} from '@extensions/chat-subscribers'
import {globals} from '@extensions/globals-base'
import {Task} from '@extensions/task'

export const createTask = (
  title: string,
  location: DataObjectId
): Hub | undefined => {
  const task = Task.createTask(title, {
    location: location,
    markSeen: true
  })

  const userId = globals.currentUserId

  setTimeout(() => {
    if (task) {
      ChatSubscribers.setSubscription(userId, task, false)
    }
  }, 5000)

  return task
}
